window.apiUrl = 'https://oracle-poll-api.dev.somnio.com';

jQuery(document).ready(function($){
    initFixedHeader();
    initKeyPop();
    initMobileAnchor();
    initAnchor();
    initChangeOnScroll();
    initCardHeight();
    initNavAccordion()
    initPolls();
    SmarterPaperSharePopup.init();
});

function zindexStart(that) {
    $(that).css('zIndex', '3');
}

function animatePoll($this, agree, disagree) {
    var pollLinkColor = $this.hasClass('agree') ? 'lighter-blue' : 'lighter-yellow';

    var tl = new TimelineMax();

    var poll = $this.parents('.poll-block'),
        details = $this.find('.details'),
        arrow = details.find('> i'),
        info = details.find('> .agree-info'),
        infoText = info.find('p'),
        infoLink = info.find('a'),
        otherAnswer = poll.find('.col-answer').not($this),
        clonedWrapper = poll.find('.progress-holder-cloned-wrapper .details'),
        progressHolder = poll.find('.progress-holder'),
        progressBarTop = progressHolder.find('.progress-top'),
        progressBarTopProgress = progressBarTop.find('.progress-bar'),
        progressBarTopValue = agree;

    progressHolder.find('a').addClass(pollLinkColor);
    progressHolder.find('p').addClass(pollLinkColor);

    if (poll.hasClass('success')) return false;

    poll.addClass('success');

    tl
        .set(progressHolder, {height: 'auto'})
        .set(info, {height: 'auto'})
        .to($this, 0.5, {width: '100%', onStart: zindexStart, onStartParams: [$this]})
        .to(otherAnswer, 0.5, {height: 0})
        .to(arrow, 1, {css: {opacity: 0, height: 0}, delay: -0.5})
        .set($this, {position: 'relative', height: 'auto'})
        .from(info, 0.5, {height: 0, delay: -0.5})
        .from(progressHolder, 0.5, {height: 0, delay: -0.5})
        .to(clonedWrapper, 0.5, {'padding-top': 25, 'padding-bottom': 25, delay: -0.5});

    infoText.each(function () {
        tl.fromTo($(this), 1, {opacity: 0, top: "-=25", visibility: 'hidden'},  {opacity: 1, top: 0, visibility: 'visible', delay: -0.7})
    });

        // .fromTo(infoLink, 1, {opacity: 0, top: "-=25", visibility: 'hidden'},  {opacity: 1, top: 0, visibility: 'visible', delay: -0.2})
    tl.fromTo(progressHolder, 1, {opacity: 0, top: "-=25", visibility: 'hidden'},  {opacity: 1, top: 0, visibility: 'visible', delay: -0.2});
        // .to(progressBarTopProgress, 0.5, {width: progressBarTopValue + '%', ease: Power0.easeOut, delay: -0.2});
}

function initPolls() {
    var polls = jQuery('.poll-block');

    // if a user has already given an answers
    // then display blocks with poll results
    if (getCookie('answers')) {
        var answers = JSON.parse(getCookie('answers'));

        for (var questionId in answers) {
            jQuery.get(window.apiUrl + '/api/question/summary/' + questionId, {}, function (data) {
                var agree = data.agree;
                var disagree = data.disagree;
                var totalAnswers = agree + disagree;

                var $answerBlock = jQuery('[data-question-id=' + data.id + ']').find('[data-answer=' + answers[data.id] + ']');
                animatePoll($answerBlock, Math.ceil(agree / totalAnswers * 100), Math.floor(disagree / totalAnswers * 100));
            });
        }
    }

    polls.each(function () {
        var el = $(this),
            progressHolder = el.find('.progress-holder').clone(),
            progressWrap = $('<div/>').addClass('col').append($('<div/>').addClass('details').append(progressHolder)),
            divCloned = $('<div/>').addClass('progress-holder-cloned-wrapper').append(progressWrap);

        el.find('.holder').append(divCloned)
    });

    polls.not('.success').on('click', '.agree, .disagree', function () {
        var $answerBlock = jQuery(this);
        var $pollBlock = jQuery(this).closest('.poll-block');
        var questionId = $pollBlock.data('question-id');
        var answer = $answerBlock.data('answer');

        var answers = JSON.parse(getCookie('answers'));
        if (answers && answers[questionId]) {
            return;
        }

        jQuery.post(window.apiUrl + '/api/question/' + questionId + '/' + answer, {}, function (data) {
            var agree = data.agree;
            var disagree = data.disagree;
            var totalAnswers = agree + disagree;

            var answers = getCookie('answers') ? JSON.parse(getCookie('answers')) : {};
            answers[data.id] = answer;
            setCookie('answers', JSON.stringify(answers), 999);

            animatePoll($answerBlock, Math.ceil(agree / totalAnswers * 100), Math.floor(disagree / totalAnswers * 100));
        });
    });
}

function initAnchor() {
    jQuery('a[href*="#"]:not([href="#"])').click(function () {
        var headerHeight = jQuery('.toc-header').outerHeight();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                if(target.selector.match(/kp\-\d+/)) {
                    jQuery('html, body').animate({
                        scrollTop: target.offset().top - headerHeight - 10
                    }, 1000);
                }  else {
                    jQuery('html, body').animate({
                        scrollTop: target.offset().top - headerHeight
                    }, 1000);
                }

                return false;
            }
        }
    });
}

function initFixedHeader() {
    var lastScroll = jQuery(window).scrollTop();
    jQuery(window).on('scroll', function (e) {
        var win = jQuery(window),
        currentScroll = win.scrollTop(),
        body = jQuery('body'),
        header = jQuery('.block'),
        headerHeight = header.outerHeight();
        if (currentScroll > headerHeight){
            body.addClass('header-sticky');
        } else {
            body.removeClass('header-sticky');
        }
        lastScroll = currentScroll;
    });
    jQuery(window).scroll();
}

function initKeyPop() {
    jQuery('.key-point-pop').each(function() {
        var holder = jQuery(this),
            flipper = holder.parents('.key-point-flip'),
            opener = holder.find('.keypoint-opener');

        opener.click(function (e) {
            flipper.toggleClass('share-active');
            return false;
        });
    });

    jQuery('.key-point-marker').on('click', function() {
        var item = jQuery(this);
        var parent = item.parent();
        parent.find('.keypoint-opener')[0].click();
    });


}

jQuery.fn.simulateClick = function() {
    return this.each(function() {
        if('createEvent' in document) {
            var doc = this.ownerDocument,
                evt = doc.createEvent('MouseEvents');
            evt.initMouseEvent('click', true, true, doc.defaultView, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
            this.dispatchEvent(evt);
        } else {
            this.click(); // IE
        }
    });
};

function initMobileAnchor() {
    $('a[href^="#"]:not([href="#"])').on('click', function () {
        var that = this;
        var attr = $(this).attr('href');
        var section_id;
        if (attr.substr(1, 3) === 'kp-') {
            var opened = 'cb21open';
            section_id = $(attr).closest('li').attr('id');
            if (!$('#' + section_id).hasClass(opened)) {
                $('#' + section_id).addClass(opened);
                $('#' + section_id + 'h3 a').simulateClick();
                $('#' + section_id).find('.cb21w1').show();
            }
        }

        if (attr.substr(1, 8) === 'section-') {
            var opened = 'cb21open';
            section_id = $(attr).closest('li').attr('id');
            if (!$('#' + section_id).hasClass(opened)) {
                $('#' + section_id).addClass(opened);
                $('#' + section_id + 'h3 a').simulateClick();
            }
        }
    });
}

function initChangeOnScroll() {
    new SmoothScroll({
        extraOffset: $('.toc-header').height() + 10 || 0,
        anchorLinks: '.toc-header .title li a',
        activeClasses: 'link',
        wheelBehavior: 'ignore',
        animDuration: 800,
        anchorActiveClass: 'title-active',
    });
}

function initCardHeight() {
    function setHeight() {
        var max = 0;
        var item = jQuery('.cw34 .cw34w4');
        // if(jQuery(window).width() > 600) {
            item.each(function() {
                var h = jQuery(this).find('a').height();
                max = Math.max(max, h);
            }).height('').height(max);
        // }
    }

    jQuery(window)
        .on('ready load', setHeight)
        .resize(setHeight)
        .resize()
}

function initNavAccordion() {
    jQuery('.nav-accordion > li').each(function(){
        var holder = jQuery(this),
        selectDrop = holder.find('.drop'),
        linkItems = selectDrop.find('a'),
        selectOpener = holder.find('> a'),
        activeClass = 'open';

        selectOpener.on('click', function(e) {
            e.preventDefault();
            $('.open').not(holder).removeClass('open');
            holder.toggleClass(activeClass);
        });


        jQuery('html').on('click touchstart pointerdown MSPointerDown', function(e) {
            var target = jQuery(e.target);

            if ($(target[0]).parent(0).hasClass('left-bar')) {
                return;
            }

            if(!target.closest(selectOpener).length && !target.closest(selectDrop).length) {
                holder.removeClass(activeClass);
            }
        });

        linkItems.on('click', function(e) {
            // e.preventDefault();
            holder.removeClass(activeClass);
            jQuery(this).parents('.toc-header').removeClass('nav-active');
        });
    });

    jQuery('.toc-header').each(function(){
        var holder = jQuery(this),
        opener = holder.find('a.menu-opener'),
        drop = holder.find('.nav-accordion'),
        activeClass = 'nav-active';

        opener.on('click', function(e) {
            e.preventDefault();
            holder.toggleClass(activeClass);
        });

        jQuery('html').on('click touchstart pointerdown MSPointerDown', function(e) {
            var target = jQuery(e.target);

            if ($(target[0]).parent(0).hasClass('left-bar')) {
                return;
            }

            if(!target.closest(opener).length && !target.closest(drop).length) {
                holder.removeClass(activeClass);
            }
        });
    });
}

/**
 * Get value by key from the cookies
 * @param {String} name
 * @return {undefined}
 */
function getCookie(name) {
    if (! document.cookie) return null

    var arr = document.cookie.split(/; */)
    var cookies = {}

    arr.forEach(function (cookie) {
        cookie = cookie.split("=")
        cookies[cookie[0]] = decodeURIComponent(cookie[1])
    })

    return cookies[name] || null
}

/**
 * Set value in cookies
 * @param {String} name
 * @param {*} value
 * @returns {undefined}
 */
function setCookie(name, value, days) {
    if (! navigator.cookieEnabled) return;

    var e = encodeURIComponent;
    var cookie = e(name) + "=" + e(value);

    if (typeof days === "number") {
        var date = new Date();
        date.setTime(date.getTime() + days * 1000 * 60 * 60 * 24);
        cookie += "; expires=" + date.toGMTString();
    }

    document.cookie = cookie
}
